import { motion } from "framer-motion";

const BATS = [
  { id: 0, src: "/halloween/bat-spread.png", top: 12, left: 10, size: 44, flap: 0.5, bob: 6, drift: 22, delay: 0 },
  { id: 1, src: "/halloween/bat-flap.png", top: 24, left: 78, size: 34, flap: 0.42, bob: 8, drift: -18, delay: 0.6 },
  { id: 2, src: "/halloween/bat-spread.png", top: 54, left: 30, size: 26, flap: 0.55, bob: 5, drift: 16, delay: 1.1 },
  { id: 3, src: "/halloween/bat-flap.png", top: 68, left: 64, size: 30, flap: 0.48, bob: 7, drift: -14, delay: 0.3 },
  { id: 4, src: "/halloween/bat-spread.png", top: 8, left: 50, size: 24, flap: 0.6, bob: 6, drift: 12, delay: 1.5 },
  { id: 5, src: "/halloween/bat-flap.png", top: 40, left: 90, size: 28, flap: 0.5, bob: 9, drift: -20, delay: 0.9 },
];

export default function HalloweenScene() {
  return (
    <div
      aria-hidden="true"
      data-testid="halloween-scene"
      className="pointer-events-none absolute inset-0 overflow-hidden z-0"
    >
      {/* Floating, flapping bats */}
      {BATS.map((b) => (
        <motion.img
          key={b.id}
          src={b.src}
          alt=""
          className="absolute select-none will-change-transform"
          style={{ top: `${b.top}%`, left: `${b.left}%`, width: b.size, height: "auto", opacity: 0.88 }}
          animate={{
            x: [0, b.drift, -b.drift * 0.6, 0],
            y: [0, -b.bob, b.bob * 0.7, 0],
            scaleY: [1, 0.7, 1],
            rotate: [-5, 5, -5],
          }}
          transition={{
            x: { duration: 9 + b.id, repeat: Infinity, ease: "easeInOut", delay: b.delay },
            y: { duration: 5 + b.id * 0.6, repeat: Infinity, ease: "easeInOut", delay: b.delay },
            scaleY: { duration: b.flap, repeat: Infinity, ease: "easeInOut" },
            rotate: { duration: 6 + b.id * 0.4, repeat: Infinity, ease: "easeInOut" },
          }}
        />
      ))}

      {/* Cozy jack-o-lantern accents */}
      {[
        { cls: "bottom-2 left-2 md:left-6 w-14 md:w-20", d: 0 },
        { cls: "bottom-3 right-4 md:right-10 w-10 md:w-14", d: 0.8 },
        { cls: "top-4 right-6 md:right-16 w-10 md:w-14", d: 1.4 },
        { cls: "top-10 left-4 md:left-16 w-8 md:w-12", d: 0.4 },
      ].map((p, i) => (
        <motion.img
          key={i}
          src="/halloween/jack-o-lantern.png"
          alt=""
          className={`absolute select-none ${p.cls}`}
          style={{ filter: "drop-shadow(0 0 16px rgba(226,113,29,0.45))" }}
          animate={{ y: [0, -5, 0], scale: [1, 1.03, 1] }}
          transition={{ duration: 3.2 + i * 0.4, repeat: Infinity, ease: "easeInOut", delay: p.d }}
        />
      ))}
    </div>
  );
}
